import React from "react";
import axios from "axios";
import FormErrorHandler from "../../components/FormErrorHandler";
import { Link } from "react-router";
import { scrollToElem } from "../../functions.js";
import { VALID_USER_ROLE_NAMES } from "../../constants";

export default class UsersForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: props.params.itemID !== undefined,
            errorMessage: {},
            eol_id: null,
            nibhv_number: null,
            initials: "",
            first_name: "",
            last_name_prefix: "",
            last_name: "",
            email: "",
            roles: [],
            is_active: 1,
            is_blocked: 0,
            read_only_fields: []
        };
    }

    updateElementState = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    updateRolesState = (e) => {
        let userRoles = this.state.roles;
        if (userRoles.includes(e.target.value)) {
            userRoles = userRoles.filter((role) => role !== e.target.value);
        } else {
            userRoles.push(e.target.value);
        }
        this.setState({
            roles: userRoles
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        let postData = {
            is_active: this.state.is_active,
            roles: this.state.roles,
            is_blocked: this.state.is_blocked
        };

        if (this.state.eol_id == null) {
            postData = {
                initials: this.state.initials,
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                last_name_prefix: this.state.last_name_prefix,
                email: this.state.email,
                roles: this.state.roles,
                is_active: this.state.is_active,
                is_blocked: this.state.is_blocked
            };
        }

        if (this.state.editMode) {
            axios
                .patch("/v1/users/" + this.props.params.itemID + "/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De gebruiker met e-mailadres '${this.state.email}' is succesvol bijgewerkt`,
                        link: `/users/edit/${response.data.uuid}`
                    });
                    this.props.router.push("/users");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        } else {
            axios
                .post("/v1/users/", postData)
                .then((response) => {
                    this.props.addGlobalMessage({
                        title: `De gebruiker met e-mailadres '${this.state.email}' is succesvol opgeslagen`,
                        link: `/users/edit/${response.data.uuid}`
                    });
                    this.props.router.push("/users");
                })
                .catch((error) => {
                    this.setState({
                        errorMessage: error.response.data
                    });
                    scrollToElem(document.querySelector(".form-error"));
                });
        }
    };

    componentDidMount() {
        if (this.state.editMode) {
            axios
                .get("/v1/users/" + this.props.params.itemID + "/")
                .then((response) => {
                    this.setState({
                        eol_id: response.data.eol_id,
                        nibhv_number: response.data.nibhv_number,
                        initials: response.data.initials,
                        first_name: response.data.first_name,
                        last_name: response.data.last_name,
                        last_name_prefix: response.data.last_name_prefix,
                        email: response.data.email,
                        roles: response.data.roles,
                        is_active: response.data.is_active ? 1 : 0,
                        is_blocked: response.data.is_blocked ? 1 : 0,
                        read_only_fields: response.data.read_only_fields
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    render() {
        return (
            <div>
                <div className="section-top">
                    <div className="breadcrumbs">
                        <Link to={"/users"}>Gebruikers</Link>
                    </div>
                    <h1>Gebruiker {this.state.editMode ? "bewerken" : "toevoegen"}</h1>
                    {this.state.nibhv_number !== null ? <p className="lighter mb-0">NIBHV-nummer: {this.state.nibhv_number}</p> : false}
                    {this.state.eol_id !== null ? (
                        <p className="lighter mb-0">Deze gebruiker is gekoppeld met een Exact Online gebruiker, daardoor zijn een aantal velden niet te bewerken.</p>
                    ) : (
                        false
                    )}
                </div>

                <form onSubmit={this.handleSubmit} ref="formref">
                    <div className="row">
                        <div className="col-6">
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Voorletters *</label>
                                        <input
                                            type="initials"
                                            tabIndex="1"
                                            name="initials"
                                            ref="initials"
                                            className="form-control form-control-md"
                                            required={true}
                                            autoFocus={true}
                                            onChange={this.updateElementState}
                                            value={this.state.initials || ""}
                                            readOnly={this.state.read_only_fields.includes("initials") || false}
                                        />
                                        <FormErrorHandler fieldName="initials" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Voornaam</label>
                                        <input
                                            type="first_name"
                                            tabIndex="2"
                                            name="first_name"
                                            ref="first_name"
                                            className="form-control form-control-md"
                                            required={false}
                                            onChange={this.updateElementState}
                                            value={this.state.first_name || ""}
                                            readOnly={this.state.read_only_fields.includes("first_name") || false}
                                        />
                                        <FormErrorHandler fieldName="first_name" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="form-group">
                                        <label>Tussenvoegsel</label>
                                        <input
                                            type="last_name_prefix"
                                            tabIndex="2"
                                            name="last_name_prefix"
                                            ref="last_name_prefix"
                                            className="form-control form-control-md"
                                            onChange={this.updateElementState}
                                            value={this.state.last_name_prefix || ""}
                                            readOnly={this.state.read_only_fields.includes("last_name_prefix") || false}
                                        />
                                        <FormErrorHandler fieldName="last_name_prefix" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Achternaam *</label>
                                        <input
                                            type="last_name"
                                            tabIndex="2"
                                            name="last_name"
                                            ref="last_name"
                                            className="form-control form-control-md"
                                            required={true}
                                            onChange={this.updateElementState}
                                            value={this.state.last_name || ""}
                                            readOnly={this.state.read_only_fields.includes("last_name") || false}
                                        />
                                        <FormErrorHandler fieldName="last_name" errorObject={this.state.errorMessage} />
                                    </div>

                                    <div className="form-group">
                                        <label>E-mailadres *</label>
                                        <input
                                            type="email"
                                            tabIndex="3"
                                            name="email"
                                            ref="email"
                                            className="form-control form-control-md"
                                            required={true}
                                            onChange={this.updateElementState}
                                            value={this.state.email || ""}
                                            readOnly={this.state.read_only_fields.includes("email") || false}
                                        />
                                        <FormErrorHandler fieldName="email" errorObject={this.state.errorMessage} />
                                    </div>
                                </div>
                                {!this.state.read_only_fields.includes("is_active") && (
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label>Actief</label>
                                            <select
                                                tabIndex="5"
                                                className="form-control form-control-md"
                                                name="is_active"
                                                ref="is_active"
                                                onChange={this.updateElementState}
                                                value={this.state.is_active}
                                            >
                                                <option value="1">Ja</option>
                                                <option value="0">Nee</option>
                                            </select>
                                            <FormErrorHandler fieldName="is_active" errorObject={this.state.errorMessage} />
                                        </div>
                                    </div>
                                )}
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Status</label>
                                        <select
                                            tabIndex="5"
                                            className="form-control form-control-md"
                                            name="is_blocked"
                                            ref="is_blocked"
                                            onChange={this.updateElementState}
                                            value={this.state.is_blocked}
                                        >
                                            <option value="1">Geblokkeerd</option>
                                            <option value="0">Niet geblokkeerd</option>
                                        </select>
                                        <FormErrorHandler fieldName="is_blocked" errorObject={this.state.errorMessage} />
                                        <p className="lighter">
                                            Een geblokkeerde gebruiker kan alleen nog inloggen als cursist.
                                            <br />
                                            Alle overige rollen en rechten worden afgenomen.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="form-group">
                                <label>Rollen van deze gebruiker</label>
                                {VALID_USER_ROLE_NAMES.map(([role, label]) => {
                                    const id = `role-${role}`;
                                    return (
                                        <div className="form-check" key={id}>
                                            <input
                                                className="form-check-input"
                                                name="roles[]"
                                                type="checkbox"
                                                value={role}
                                                id={id}
                                                checked={this.state.roles.includes(role)}
                                                onChange={this.updateRolesState}
                                            />
                                            <label className="form-check-label" htmlFor={id}>
                                                {label}
                                            </label>
                                        </div>
                                    );
                                })}
                                <div className="form-check">
                                    <input className="form-check-input" name="roles[]" type="checkbox" disabled value="student" id="role-student" checked={true} />
                                    <label className="form-check-label" htmlFor="role-student">
                                        Cursist
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <FormErrorHandler fieldName="non_field_errors" errorObject={this.state.errorMessage} />

                    <div className="form-group">
                        <button className="btn btn-primary" type="submit">
                            Opslaan
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}
